import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { SettingService } from './setting.service';

@Injectable({ providedIn: 'root' })
export class EncryptionDecryptionService {
  encrypt(strToEncrypt: string): string {
    try {
      let secretKey = SettingService.getApplicationPropertiesValue('SECRETKEY');
      let iv = SettingService.getApplicationPropertiesValue('IV');

      const key = CryptoJS.enc.Utf8.parse(secretKey);
      const ivBytes = CryptoJS.enc.Utf8.parse(iv);
      if (this.isEncrypted(strToEncrypt)) {
        return strToEncrypt;
      } else {
        const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(strToEncrypt), key, {
          iv: ivBytes,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
        return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
      }
    } catch (e) {
      console.error(e);
      return strToEncrypt;
    }
  }

  decrypt(strToDecrypt: string): string {
    try {
      let secretKey = SettingService.getApplicationPropertiesValue('SECRETKEY');
      let iv = SettingService.getApplicationPropertiesValue('IV');
      const key = CryptoJS.enc.Utf8.parse(secretKey);
      const ivBytes = CryptoJS.enc.Utf8.parse(iv);

      const decrypted = CryptoJS.AES.decrypt(
        {
          ciphertext: CryptoJS.enc.Base64.parse(strToDecrypt),
        } as any,
        key,
        {
          iv: ivBytes,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );

      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (e) {
      console.error('errro while decrypt=========>' + e);
      return strToDecrypt;
    }
  }

  isEncrypted(value: string): boolean {
    if (!value || typeof value !== 'string') {
      return false;
    }
    if (value.length < 16) {
      return false;
    }
    const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/;

    if (!base64Regex.test(value)) {
      return false;
    }

    try {
      const decrypted = this.decrypt(value);
      return !!decrypted && decrypted.trim().length > 0 && decrypted !== value;
    } catch {
      return false;
    }
  }
}
